export default __webpack_public_path__ + "static/media/ceramica san juan de oriente.d25a2165.jpg";